module.exports = __webpack_public_path__ + "static/img/BH04.18c98b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BH04.jpg
// module id = hvnq
// module chunks = 1